import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPolicyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* Hero */}
      <div className="bg-gray-800 pt-28 pb-14">
        <div className="max-w-4xl mx-auto px-6 md:px-10 text-center">
          <span className="text-yellow-400 text-xs font-bold tracking-widest uppercase">PRIVACY POLICY</span>
          <h1 className="text-white font-bold text-3xl md:text-4xl mt-3">プライバシーポリシー</h1>
          <p className="text-gray-400 text-sm mt-3">個人情報の取り扱いについて</p>
        </div>
      </div>

      {/* Content */}
      <main className="flex-1 bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-100">

            <p className="text-gray-600 text-sm leading-relaxed mb-10">
              株式会社マスター・マインド・グループ（以下「当社」）は、お客様の個人情報の保護を重要な責務と認識し、
              以下のプライバシーポリシーに従って個人情報を適切に取り扱います。
            </p>

            {[
              {
                title: '1. 個人情報の定義',
                content: '個人情報とは、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日その他の記述等により特定の個人を識別することができるもの（他の情報と容易に照合することができ、それにより特定の個人を識別することができることとなるものを含む）をいいます。',
              },
              {
                title: '2. 個人情報の収集',
                content: '当社は、お問い合わせフォーム、メール、電話等を通じて、お客様の氏名、会社名、メールアドレス、電話番号、その他お問い合わせ内容等の個人情報を収集することがあります。個人情報の収集は、適法かつ公正な手段によって行います。',
              },
              {
                title: '3. 個人情報の利用目的',
                content: '当社は、収集した個人情報を以下の目的のために利用します。\n・お問い合わせへの回答および対応\n・サービスのご提供およびご案内\n・契約の履行および管理\n・法令に基づく対応\n・その他、上記に付随する業務',
              },
              {
                title: '4. 個人情報の第三者提供',
                content: '当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。\n・お客様の同意がある場合\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要がある場合\n・公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合',
              },
              {
                title: '5. 個人情報の管理',
                content: '当社は、個人情報の漏洩、滅失またはき損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業員に対して、必要かつ適切な監督を行います。',
              },
              {
                title: '6. 個人情報の開示・訂正・削除',
                content: 'お客様は、当社が保有するご自身の個人情報について、開示、訂正、追加、削除、利用停止または消去を請求することができます。ご請求の際は、下記お問い合わせ先までご連絡ください。',
              },
              {
                title: '7. Cookieの使用',
                content: '当社のウェブサイトでは、サービスの向上を目的としてCookieを使用することがあります。Cookieの使用を希望されない場合は、ブラウザの設定によりCookieを無効にすることができます。ただし、Cookieを無効にした場合、一部のサービスが正常に機能しない場合があります。',
              },
              {
                title: '8. プライバシーポリシーの変更',
                content: '当社は、法令の変更や事業内容の変化等に応じて、本プライバシーポリシーを変更することがあります。変更後のプライバシーポリシーは、当社ウェブサイトに掲載した時点から効力を生じるものとします。',
              },
              {
                title: '9. お問い合わせ',
                content: '個人情報の取り扱いに関するお問い合わせは、以下の窓口までご連絡ください。\n\n株式会社マスター・マインド・グループ\n代表者：小西　真平\n〒530-0043 大阪府大阪市北区天満1丁目4-19 キオプラザ天満橋\n電話番号：050-8896-2380\nメールアドレス：keiri@master-mind-group.com\n受付時間：平日 9:00〜18:00',
              },
            ].map((section) => (
              <div key={section.title} className="mb-8">
                <h2 className="text-gray-800 font-bold text-base mb-3 flex items-center gap-2">
                  <span className="w-1 h-5 bg-yellow-400 rounded-full inline-block" />
                  {section.title}
                </h2>
                <p className="text-gray-600 text-sm leading-relaxed whitespace-pre-line pl-3">
                  {section.content}
                </p>
              </div>
            ))}

            <div className="mt-10 pt-6 border-t border-gray-100 text-right">
              <p className="text-gray-400 text-xs mt-1">株式会社マスター・マインド・グループ</p>
            </div>
          </div>

          {/* Back Button */}
          <div className="mt-8 text-center">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-gray-800 text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-gray-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-left-line" />
              トップページへ戻る
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
